// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".change-requests__clickable_e5738110{cursor:pointer}.change-requests__clickable_e5738110:hover td{transition:background-color .2s;background-color:#dceffa}", ""]);
// Exports
export var changeRequestsClickable = "change-requests__clickable_e5738110";
export default ___CSS_LOADER_EXPORT___;
